import { FC } from 'react';
import { Helmet } from 'react-helmet-async';
import {
  Box,
  Container,
  Typography,
} from '@mui/material';
import useSession from 'src/hooks/useSession';
import { useLocation } from 'react-router-dom';
import RegisterBlock from 'src/components/authentication/register/RegisterBlock';
import { BookingSuccessDetails } from 'src/components/booking';
import useAuth from 'src/hooks/useAuth';
import { BookingSuccessState } from 'src/types/booking/bookingSuccessState';
import useSettings from 'src/hooks/useSettings';
import TipsAndUpdatesIcon from '@mui/icons-material/TipsAndUpdates';
import { Stack } from '@mui/system';
import { isCustomDomain } from 'src/hooks/useCustomDomain';
import PromotionBooking from 'src/components/promotions/PromotionBooking';

const BookingSuccess: FC = () => {
  const { session } = useSession();
  const location = useLocation();
  const { settings } = useSettings();
  const { isAuthenticated } = useAuth();
  const bookingSuccessState = location.state ? (location.state as BookingSuccessState) : null;

  if (!bookingSuccessState) return null;

  const getPageTitle = () => {
    if (isCustomDomain()) {
      return 'Buchung abgeschlossen';
    }
    return 'Kumao | Buchung abgeschlossen';
  };

  return (
    <>
      <Helmet>
        <title>{getPageTitle()}</title>
      </Helmet>
      <Container
        maxWidth={settings.compact ? 'lg' : false}
        sx={{ pt: 4 }}
      >
        <BookingSuccessDetails
          colorCode="#000000"
          organization={bookingSuccessState.organization}
          selectedServices={bookingSuccessState.selectedServices}
          selectedEvent={bookingSuccessState.selectedEvent}
          icsEntry={bookingSuccessState.icsEntry}
        />
        <PromotionBooking />
        {(!isAuthenticated) && !isCustomDomain() && (
          <Box sx={{ mt: 4, p: 3, border: '1px solid #e0e0e0', borderRadius: 2, backgroundColor: '#f9f9f9' }}>
            <Stack
              direction="row"
              alignItems="center"
              spacing={2}
              sx={{ pb: 2 }}
            >
              <TipsAndUpdatesIcon
                fontSize="large"
                color="primary"
              />
              <Typography
                variant="h6"
                sx={{ fontWeight: 600, color: '#333' }}
              >
                Tipp: Für noch einfachere Buchungen
              </Typography>
            </Stack>
            <Typography
              variant="body1"
              sx={{ mb: 2, pl: 3, color: 'text.secondary' }}
            >
              Registriere dich jetzt bei Kumao und erlebe einen noch schnelleren und personalisierten Buchungsprozess.
            </Typography>
            <RegisterBlock
              firstName={session?.userData?.firstName}
              lastName={session?.userData?.lastName}
              email={session?.userData?.userEmail}
              isBookingSuccessRegister
              disableGutters
            />
          </Box>
        )}
      </Container>
    </>
  );
};

export default BookingSuccess;
